import { MapPin } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { images } from "../data/images";
import { missions } from "../data/missions";
import Reveal from "../components/Reveal";

const Missions = () => {
    const { lang, t } = useLanguage();

    return (
        <main data-testid="missions-page" className="bg-white">
            {/* Header */}
            <section className="relative pt-32 pb-16 md:pt-44 md:pb-24 overflow-hidden border-b border-[var(--sodeco-border)]">
                <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-7">
                        <Reveal>
                            <span className="text-[11px] uppercase tracking-[0.4em] text-[var(--sodeco-muted)]">
                                {t.missions.eyebrow}
                            </span>
                            <div className="mt-3">
                                <span className="yellow-rule" />
                            </div>
                        </Reveal>
                        <Reveal delay={100}>
                            <h1
                                data-testid="missions-title"
                                className="mt-6 font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05]"
                            >
                                {t.missions.title}
                            </h1>
                        </Reveal>
                        <Reveal delay={200}>
                            <p className="mt-6 max-w-xl text-[var(--sodeco-muted)] leading-relaxed">
                                {t.missions.subtitle}
                            </p>
                        </Reveal>
                    </div>
                    <div className="lg:col-span-5">
                        <Reveal delay={150}>
                            <img
                                src={images.missionsHeader}
                                alt=""
                                className="w-full h-[280px] md:h-[380px] object-cover"
                                loading="lazy"
                            />
                        </Reveal>
                    </div>
                </div>
            </section>

            {/* Timeline */}
            <section className="relative max-w-6xl mx-auto px-6 md:px-12 py-20 md:py-28">
                <div className="relative">
                    <div
                        className="timeline-line absolute top-0 bottom-0 w-[2px] left-6 md:left-1/2 md:-translate-x-1/2"
                        aria-hidden
                    />

                    <ul className="space-y-16 md:space-y-24">
                        {missions.map((m, i) => {
                            const isLeft = i % 2 === 0;
                            return (
                                <li
                                    key={m.id}
                                    data-testid={`mission-${m.id}`}
                                    className="relative"
                                >
                                    <span
                                        className="absolute left-6 md:left-1/2 -translate-x-1/2 top-3 w-4 h-4 rounded-full border-2 border-white"
                                        style={{ background: "var(--sodeco-yellow)" }}
                                        aria-hidden
                                    />
                                    <div
                                        className={`grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 ${
                                            isLeft ? "" : "md:[&>*:first-child]:order-2"
                                        }`}
                                    >
                                        <Reveal className={`pl-16 md:pl-0 ${isLeft ? "md:text-right md:pr-12" : "md:pl-12"}`}>
                                            <div
                                                className="font-serif text-5xl md:text-7xl font-light leading-none"
                                                style={{ color: "var(--sodeco-yellow-deep)" }}
                                            >
                                                {m.year}
                                            </div>
                                            <div
                                                className="mt-3 text-xs uppercase tracking-[0.25em] text-[var(--sodeco-muted)] flex items-center gap-2 md:justify-end"
                                                style={isLeft ? {} : { justifyContent: "flex-start" }}
                                            >
                                                <MapPin size={12} />
                                                {lang === "es" ? m.location_es : m.location_en}
                                            </div>
                                            <h3 className="mt-4 font-serif text-2xl md:text-3xl leading-tight">
                                                {lang === "es" ? m.title_es : m.title_en}
                                            </h3>
                                            <p className="mt-4 text-[var(--sodeco-muted)] leading-relaxed">
                                                {lang === "es" ? m.description_es : m.description_en}
                                            </p>
                                        </Reveal>

                                        <Reveal delay={120} className={`pl-16 md:pl-0 ${isLeft ? "md:pl-12" : "md:pr-12"}`}>
                                            <figure className="overflow-hidden border border-[var(--sodeco-border)]">
                                                <img
                                                    src={m.image}
                                                    alt={lang === "es" ? m.title_es : m.title_en}
                                                    className="w-full h-[280px] md:h-[360px] object-cover hover-grow"
                                                    loading="lazy"
                                                />
                                            </figure>
                                        </Reveal>
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </section>
        </main>
    );
};

export default Missions;
